import React from "react";
import { Box, Typography } from "@mui/material";

export const TEMPLATE_WIDTH = 3508;
export const TEMPLATE_HEIGHT = 2480;

export const config = {
  width: TEMPLATE_WIDTH,
  height: TEMPLATE_HEIGHT,
  regions: [
    { id: "hero_front", x: 0.05, y: 0.2, width: 0.44, height: 0.66 },
    { id: "hero_back", x: 0.52, y: 0.2, width: 0.44, height: 0.66 },
    { id: "opt_1", x: 0.05, y: 0.88, width: 0.2, height: 0.09 },
    { id: "opt_2", x: 0.27, y: 0.88, width: 0.2, height: 0.09 },
  ],
  textFields: [
    {
      id: "marca",
      x: 0.05,
      y: 0.04,
      width: 0.25,
      height: 0.05,
      fontSize: 48,
      fontWeight: "bold",
      color: "#ffffff",
      backgroundColor: "#111111",
    },
  ],
};

const heroBox = {
  border: "1px solid #d3d3d3",
  borderRadius: "8px",
  backgroundColor: "#fafafa",
  overflow: "hidden",
  position: "relative",
};

function PlantillaPPTBikerPro({ marca = "MARCA", className }) {
  return (
    <Box
      className={className}
      sx={{
        width: "100%",
        height: "100%",
        aspectRatio: `${TEMPLATE_WIDTH}/${TEMPLATE_HEIGHT}`,
        bgcolor: "#f5f5f5",
        border: "1px solid #d7d7d7",
        borderRadius: "10px",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Typography
        sx={{
          position: "absolute",
          left: "5%",
          top: "2.5%",
          fontSize: ".16rem",
          color: "#262626",
          fontWeight: 700,
        }}
      >
        PPT BIKER JACKET
      </Typography>
      <Box
        sx={{
          position: "absolute",
          left: "5%",
          top: "6%",
          width: "25%",
          height: "5%",
          bgcolor: "#111",
          color: "#fff",
          px: 0.9,
          borderRadius: "4px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontSize: ".25rem", fontWeight: 700 }}>
          {marca}
        </Typography>
      </Box>

      <Box sx={{ position: "absolute", left: "5%", top: "20%", width: "44%", height: "66%", ...heroBox }}>
        <Box sx={{ position: "absolute", inset: "3%", border: "1px dashed #a2a2a2", borderRadius: "6px" }} />
      </Box>
      <Box sx={{ position: "absolute", left: "52%", top: "20%", width: "44%", height: "66%", ...heroBox }}>
        <Box sx={{ position: "absolute", inset: "3%", border: "1px dashed #a2a2a2", borderRadius: "6px" }} />
      </Box>

      <Typography sx={{ position: "absolute", left: "7%", top: "87.2%", fontSize: ".12rem", color: "#4a4a4a", fontWeight: 700 }}>
        OPT 1
      </Typography>
      <Typography sx={{ position: "absolute", left: "29%", top: "87.2%", fontSize: ".12rem", color: "#4a4a4a", fontWeight: 700 }}>
        OPT 2
      </Typography>
      <Box sx={{ position: "absolute", left: "5%", top: "88%", width: "20%", height: "9%", ...heroBox }}>
        <Box sx={{ position: "absolute", inset: "7%", border: "1px dashed #a2a2a2", borderRadius: "5px" }} />
      </Box>
      <Box sx={{ position: "absolute", left: "27%", top: "88%", width: "20%", height: "9%", ...heroBox }}>
        <Box sx={{ position: "absolute", inset: "7%", border: "1px dashed #a2a2a2", borderRadius: "5px" }} />
      </Box>
    </Box>
  );
}

export default PlantillaPPTBikerPro;
